import { render, staticRenderFns } from "./specializationUs.vue?vue&type=template&id=d33b1ef8&scoped=true&"
import script from "./specializationUs.vue?vue&type=script&lang=js&"
export * from "./specializationUs.vue?vue&type=script&lang=js&"
import style0 from "./specializationUs.vue?vue&type=style&index=0&id=d33b1ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33b1ef8",
  null
  
)

export default component.exports